import React from 'react';
import cn from 'classnames';

function NewSectionTitle({
  headingStyle,
  text,
  highlightedText,
  placementPage,
  underlineStyle,
  videoCarousel,
  testimonial,
  isMobile
}) {
  return (
    <h2
      className={cn(
        'flex flex-wrap items-center justify-center gap-[8px] text-center font-satoshi-medium text-[30px] font-semibold leading-9 md:font-satoshi-bold md:text-[36px] md:leading-none',
        headingStyle,
        placementPage &&
          '!text-[20px] md:!text-[24px] !font-semibold !leading-[140%] !tracking-[-0.4px] !text-[#1F1F1F]',
        videoCarousel && '!text-white !justify-start',
        testimonial && '!justify-start'
      )}
    >
      {text}{' '}
      {highlightedText && (
        <span
          className={cn(
            'relative -top-3 text-red underline underline-offset-8',
            underlineStyle,
            placementPage &&
              '!-top-2 !text-[24px] !font-semibold !leading-[140%] !tracking-[-0.4px] !text-[#F00037]'
          )}
        >
          {highlightedText}
        </span>
      )}
    </h2>
  );
}

export default NewSectionTitle;
